<template>
    <div class="wrapClass imageselect">
        <span v-if="hasClose" class="imageselect-close" @click="handleClose"><i class="zmdi zmdi-close"></i></span>
        <div class="input-group" style="width: 100%">
            <span v-if="hasLabel" class="input-group-addon">{{label}}</span>
            <div class="fg-line" style="display: flex">
                <div v-loading="imageLoading" :element-loading-text="loadingText">
                    <img class="jc-border-color" @click="clickOntheImage" :style="imageStyle" :src="imageDate"/>
                </div>
                <input type="file" style="display:none;"
                       accept="image/*,image/bmp, image/gif, image/jpeg,image/x-png" id="fileHeadImg"/>
                <slot name="rightContent"></slot>
            </div>
        </div>
    </div>
</template>
<style lang="less" rel="stylesheet/less">
    .imageselect {
        position: relative;
        .imageselect-close {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 2;
            font-size: 14px;
            line-height: 14px;
            cursor: pointer;
        }
    }
</style>

<script>
    import AccountService from 'services/AccountService.js'

    function getdefaltFaceImageData() {
        return "data:image/gif;base64,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"
    }

    export default {
        name: 'c-imageselect',
        props: {
            /*图片是否可以点击*/
            isEnableByImage: {
                type: Boolean,
                default: function () {
                    return true
                }
            },
            /*默认占位图片*/
            placeholderImage: {
                type: String,
                default: function () {
                    return null
                }
            },
            /*左边Label*/
            label: {
                type: String,
                default: function () {
                    return "";
                }
            },
            /*图片URL*/
            value: {
                type: String,
                default: function () {
                    return null;
                }
            },
            /*图片样式*/
            imageStyle: {
                type: Object,
                default: function () {
                    return {
                        width: '70px',
                        height: '70px',
                        'border-radius': '35px',
                        'border': '1px solid'
                    }
                }
            },
            hasClose: {
                type: Boolean,
                default: false
            },
            loadingText: {
                type: String,
                default: '上传中...'
            }
        },
        data() {
            return {
                imageLoading: false,
                imageDate: getdefaltFaceImageData()
            }
        },
        mounted() {
            this.setImageURL();
        },
        watch: {
            value() {
                this.setImageURL();
            }
        },
        computed: {
            hasLabel() {
                return this.label && this.label.length > 0;
            }
        },
        methods: {
            setImageURL() {
                if (this.value && this.value.length > 0) {
                    this.imageDate = this.value;
                }
                else if (this.placeholderImage) {
                    this.imageDate = this.placeholderImage;
                }
                else {
                    this.imageDate = getdefaltFaceImageData();
                }
            },
            clickOntheImage() {
                if (this.isEnableByImage) {
                    this.selectImage();
                }
            },
            selectImage() {
                var vmObj = this;
                $("#fileHeadImg").click();
                $("#fileHeadImg").unbind("change");
                $("#fileHeadImg").change(function () {
                    if ($(this).val() != "") {
                        var reader = new FileReader();
                        reader.onload = function (evt) {
                            vmObj.imageDate = evt.target.result;
                            var data = new FormData();
                            vmObj.imageLoading = true;
                            data.append('image', document.getElementById('fileHeadImg').files[0]);
                            AccountService.uploadImage(data).then(function (ret) {
                                if (ret && ret.url) {
                                    vmObj.imageLoading = false;
                                    vmObj.$emit('input', ret.url);
                                }
                            }).catch(function () {
                                vmObj.imageLoading = false;
                                vmObj.$toast.warning("图片上传失败");
                            });
                        };
                        reader.readAsDataURL(this.files[0]);
                    }
                });
            },
            handleClose() {
                this.imageDate = this.placeholderImage;
                this.$emit('input', null);
            }
        },
        components: {}
    }
</script>



// WEBPACK FOOTER //
// imageselect.vue?2d15f144